/**
 * @author Yaochao
 * @date 2021/8/4 14:32
 * @description
 */
import React from 'react'
import QuestionTip from "../questionTip";

/**
 *
 * @param title 左侧文本
 * @param colon 是否自动加上:,默认true
 * @param tooltip 问号提示
 * @param required 是否显示必填红*
 * @param titleWidth title宽度
 * @param conWidth 内容宽度
 * @returns {*}
 * @constructor
 */
const ZkFormItem = (props) => {

    const {title: title, colon: colon, tooltip: tooltip, required: required, titleWidth: titleWidth, conWidth: conWidth} = props;

    let titleStyle = {
        width: titleWidth ? titleWidth : 'auto'
    };

    let conStyle = {
        width: conWidth ? conWidth : 'auto'
    };

    return (
        <div className={'zkFormItem'}>
            <label style={titleStyle} className='zkFormItemTitle'>{required ?
                <span className='text-danger'>*</span> : ''}{title}{tooltip ?
                <QuestionTip title={tooltip}/> : ''}{colon ? '：' : ''}</label>
            <div style={conStyle} className='zkFormItemCon'>
                {props.children}
            </div>
        </div>
    )
};

export default ZkFormItem